import React, { useEffect } from 'react';

export const MaintenanceComponent: React.FC = () => {
  useEffect(() => {
    window.location.href = '/maintenance';
  }, []);

  return null;
};
